<div class="menu">
  @for (menuItem of items(); track menuItem.route) {
    <div [class.margin-top]="menuItem.marginTop">
      @if (menuItem.children) {
        <a
          (click)="menu.toggle($event)"
          [class.expanded]="menu.visible"
          [attr.data-qa]="'side-menu-link-sub-' + (menuItem.dataQa || menuItem.route.path || menuItem.route.title)"
        >
          <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: menuItem }" />
        </a>
        <p-menu
          #menu
          appendTo="body"
          [popup]="true"
          [model]="menuItem.children"
          [styleClass]="'side-menu-sub' + (isMinimized() ? ' minimized' : '')"
        >
          <ng-template #item let-item>
            <a
              [flNavRouterLink]="item.route"
              [attr.data-qa]="'side-menu-link-sub-' + (item.dataQa || item.route.path || item.route.title)"
              >{{ item.route.title | translate }}</a
            >
          </ng-template>
        </p-menu>
      } @else if (menuItem.route.path.startsWith("http")) {
        <a
          [href]="menuItem.route.path"
          target="_blank"
          [attr.data-qa]="'side-menu-link-' + (menuItem.dataQa || menuItem.route.title)"
        >
          <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: menuItem }" />
        </a>
      } @else {
        <a
          [flNavRouterLink]="menuItem.route"
          routerLinkActive="active"
          [attr.data-qa]="'side-menu-link-' + menuItem.route.path"
        >
          <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: menuItem }" />
        </a>
      }
    </div>
  }
</div>
<p-divider />
<a (click)="isMinimized.set(!isMinimized())" [attr.data-qa]="'side-menu-toggle'">
  <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: toggleItem() }" />
</a>

<ng-template #itemTpl let-menuItem>
  <fl-icon [name]="menuItem.icon" [size]="(menuItem.icon.startsWith('pi-fl') ? 32 : 20) + 'px'" />
  @if (!isMinimized() && menuItem.route.title) {
    <p animate.enter="label-enter" animate.leave="label-leave">{{ menuItem.route.title | translate }}</p>
  }
</ng-template>
